import React, { Component } from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';
import EventMap from './map';

import EventArchive from './components/event-archive';


var EventMapElement = document.getElementById( 'confMap' );
if ( EventMapElement && mapDetails ) {
	ReactDom.render( <EventMap events={ mapDetails } />, EventMapElement );
}

export default class EventArchiveRender extends Component {
	render() {
		return (<Provider store={ store }>
				<EventArchive/>
			</Provider>
		);
	}
}

var EventsReactElement = document.getElementById( 'EventsReactElement' );
if ( EventsReactElement ) {
	ReactDom.render( <EventArchiveRender />, EventsReactElement );
}